<template>
	<div class="m-accordion m-accordion--default">
		<div class="m-accordion__item">
			<div class="m-accordion__item-head collapsed" role="tab" data-toggle="collapse" href="#m_accordion_1_item_1_body">
				<span class="m-accordion__item-icon"><i class="fa flaticon-cogwheel"></i></span>
				<span class="m-accordion__item-title">Cài đặt thông số</span>
				<span class="m-accordion__item-mode"></span>
			</div>
			<div class="m-accordion__item-body collapse" id="m_accordion_1_item_1_body">
				<div class="m-accordion__item-content accordion-config">
					<config-limit title="Giới hạn cược ngày" type="limit_day" :limitConfig="limitConfig"></config-limit>
					<div class="m-separator m-separator--space m-separator--dashed"></div>
					<config-limit v-if="user.role=='admin' && role=='admin'" title="Giới hạn 1 lần cược" type="limit_once" :limitConfig="limitConfig"></config-limit>
					<div v-if="user.role=='admin' && role=='admin'" class="m-separator m-separator--space m-separator--dashed"></div>
					<div class="class">
						<ul class="nav nav-tabs" role="tablist">
							<li class="nav-item m-tabs__item" v-for="(configs, cls, index) in heConfig">
								<a :class="'nav-link m-tabs__link ' + (index == 0 ? 'active' : '')" data-toggle="tab" role="tab" :href="'#m_tabs_he_' + (-1*cls)">
									Hệ {{String.fromCharCode(-1*cls+64).toUpperCase()}}
								</a>
							</li>
						</ul>
						<div class="tab-content">
							<div :class="'tab-pane '+(index == 0 ? 'active' : '')" v-for="(configs, cls, index) in heConfig" :id="'m_tabs_he_' + (-1*cls)" role="tabpanel">
								<table class="tab-content table table-config">
									<thead>
										<tr>
											<th rowspan="2"></th>
											<th colspan="2">Bắc</th>
											<th colspan="2">Trung</th>
											<th colspan="2">Nam</th>
										</tr>
										<tr>
											<th>Cò</th>
											<th>Trúng</th>
											<th>Cò</th>
											<th>Trúng</th>
											<th>Cò</th>
											<th>Trúng</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th scope="row">2D</th>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['1']" v-if="[1,2,4].indexOf(parseInt(prop)) >= 0" :style="prop!=1?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['1']['commission']" :classid="cls" v-model="mb2dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['1']" v-if="[1,2,4].indexOf(parseInt(prop)) >= 0" :style="prop!=1?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['1']['rate']" :classid="cls" v-model="mb2dRate[cls]" />
											</td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['4']" v-if="[1,2,3,5].indexOf(parseInt(prop)) >= 0" :style="prop!=1?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['1']['commission']" :classid="cls" v-model="mt2dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['4']" v-if="[1,2,3,5].indexOf(parseInt(prop)) >= 0" :style="prop!=1?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['1']['rate']" :classid="cls" v-model="mt2dRate[cls]" />
											</td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['2']" v-if="[1,2,3,5].indexOf(parseInt(prop)) >= 0" :style="prop!=1?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['1']['commission']" :classid="cls" v-model="mn2dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['2']" v-if="[1,2,3,5].indexOf(parseInt(prop)) >= 0" :style="prop!=1?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['1']['rate']" :classid="cls" v-model="mn2dRate[cls]" />
											</td>
										</tr>
										<tr>
											<th scope="row">3D</th>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['1']" v-if="[6,7,9].indexOf(parseInt(prop)) >= 0" :style="prop!=6?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['6']['commission']" :classid="cls" v-model="mb3dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['1']" v-if="[6,7,9].indexOf(parseInt(prop)) >= 0" :style="prop!=6?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['6']['rate']" :classid="cls" v-model="mb3dRate[cls]" />
											</td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['4']" v-if="[6,7,8,10].indexOf(parseInt(prop)) >= 0" :style="prop!=6?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['6']['commission']" :classid="cls" v-model="mt3dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['4']" v-if="[6,7,8,10].indexOf(parseInt(prop)) >= 0" :style="prop!=6?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['6']['rate']" :classid="cls" v-model="mt3dRate[cls]" />
											</td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['2']" v-if="[6,7,8,10].indexOf(parseInt(prop)) >= 0" :style="prop!=6?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['6']['commission']" :classid="cls" v-model="mn3dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['2']" v-if="[6,7,8,10].indexOf(parseInt(prop)) >= 0" :style="prop!=6?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['6']['rate']" :classid="cls" v-model="mn3dRate[cls]" />
											</td>
										</tr>
										<tr>
											<th scope="row">4D</th>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['1']" v-if="[11,12].indexOf(parseInt(prop)) >= 0" :style="prop!=11?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['11']['commission']" :classid="cls" v-model="mb4dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['1']" v-if="[11,12].indexOf(parseInt(prop)) >= 0" :style="prop!=11?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['11']['rate']" :classid="cls" v-model="mb4dRate[cls]" />
											</td>
											<td class="commission">
												<input  v-for="(cfg, prop) in configs['4']" v-if="[11,13].indexOf(parseInt(prop)) >= 0" :style="prop!=11?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['11']['commission']" :classid="cls" v-model="mt4dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['4']" v-if="[11,13].indexOf(parseInt(prop)) >= 0" :style="prop!=11?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['11']['rate']" :classid="cls" v-model="mt4dRate[cls]" />
											</td>
											<td class="commission">
												<input  v-for="(cfg, prop) in configs['2']" v-if="[11,13].indexOf(parseInt(prop)) >= 0" :style="prop!=11?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['11']['commission']" :classid="cls" v-model="mn4dCommission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['2']" v-if="[11,13].indexOf(parseInt(prop)) >= 0" :style="prop!=11?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['11']['rate']" :classid="cls" v-model="mn4dRate[cls]" />
											</td>
										</tr>
										<tr>
											<th scope="row">Đá thẳng</th>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['1']" v-if="[14].indexOf(parseInt(prop)) >= 0" :style="prop!=14?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['14']['commission']" :classid="cls" v-model="mbXien2Commission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['1']" v-if="[14].indexOf(parseInt(prop)) >= 0" :style="prop!=14?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="1" :propId="prop" :origin="configs['1']['14']['rate']" :classid="cls" v-model="mbXien2Rate[cls]" />
											</td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['4']" v-if="[14].indexOf(parseInt(prop)) >= 0" :style="prop!=14?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['14']['commission']" :classid="cls"v-model="mtXien2Commission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['4']" v-if="[14].indexOf(parseInt(prop)) >= 0" :style="prop!=14?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="4" :propId="prop" :origin="configs['4']['14']['rate']" :classid="cls" v-model="mtXien2Rate[cls]" />
											</td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['2']" v-if="[14].indexOf(parseInt(prop)) >= 0" :style="prop!=14?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['14']['commission']" :classid="cls" v-model="mnXien2Commission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['2']" v-if="[14].indexOf(parseInt(prop)) >= 0" :style="prop!=14?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="2" :propId="prop" :origin="configs['2']['14']['rate']" :classid="cls" v-model="mnXien2Rate[cls]" />
											</td>
										</tr>
										<tr>
											<th scope="row">Đá Xiên</th>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td class="commission">
												<input v-for="(cfg, prop) in configs['3']" v-if="[17].indexOf(parseInt(prop)) >= 0" :style="prop!=17?'display:none;':''" class="comm_config form-control form-control-sm m-input" gameId="3" :propId="prop" :origin="configs['3']['17']['commission']" :classid="cls" v-model="mnDaXien2Commission[cls]" />
											</td>
											<td class="rate">
												<input v-for="(cfg, prop) in configs['3']" v-if="[17].indexOf(parseInt(prop)) >= 0" :style="prop!=17?'display:none;':''" class="rate_config form-control form-control-sm m-input" gameId="3" :propId="prop" :origin="configs['3']['17']['rate']" :classid="cls" v-model="mnDaXien2Rate[cls]" />
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from "../../utilities";
	import AccountConfigLimit from './AccountConfigLimit';

	export default {
		props: ["uclass", "mode", "role"],
		created(){
			this.loadUserConfig();
		},
		data() {
			return{
				
				limitConfig: {},
				heConfig: {},

				mb2dCommission: [],
				mb2dRate: [],
				mt2dCommission: [],
				mt2dRate: [],
				mn2dCommission: [],
				mn2dRate: [],

				mb3dCommission: [],
				mb3dRate: [],
				mt3dCommission: [],
				mt3dRate: [],
				mn3dCommission: [],
				mn3dRate: [],

				mb4dCommission: [],
				mb4dRate: [],
				mt4dCommission: [],
				mt4dRate: [],
				mn4dCommission: [],
				mn4dRate: [],

				mbXien2Commission: [],
				mbXien2Rate: [],
				mtXien2Commission: [],
				mtXien2Rate: [],
				mnXien2Commission: [],
				mnXien2Rate: [],

				mnDaXien2Commission: [],
				mnDaXien2Rate: []
			}
		},
		components: {
			'config-limit': AccountConfigLimit
		},
		computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},
		watch: {
			heConfig: function(configs){
				let he = Object.keys(configs);
				for (let i = 0; i < he.length; i++) {
					this.mb2dCommission[he[i]] = configs[he[i]]["1"]["1"].commission;
					this.mb2dRate[he[i]] = configs[he[i]]["1"]["1"].rate;
					this.mt2dCommission[he[i]] = configs[he[i]]["4"]["1"].commission;
					this.mt2dRate[he[i]] = configs[he[i]]["4"]["1"].rate;
					this.mn2dCommission[he[i]] = configs[he[i]]["2"]["1"].commission;
					this.mn2dRate[he[i]] = configs[he[i]]["2"]["1"].rate;

					this.mb3dCommission[he[i]] = configs[he[i]]["1"]["6"].commission;
					this.mb3dRate[he[i]] = configs[he[i]]["1"]["6"].rate;
					this.mt3dCommission[he[i]] = configs[he[i]]["4"]["6"].commission;
					this.mt3dRate[he[i]] = configs[he[i]]["4"]["6"].rate;
					this.mn3dCommission[he[i]] = configs[he[i]]["2"]["6"].commission;
					this.mn3dRate[he[i]] = configs[he[i]]["2"]["6"].rate;

					this.mb4dCommission[he[i]] = configs[he[i]]["1"]["11"].commission;
					this.mb4dRate[he[i]] = configs[he[i]]["1"]["11"].rate;
					this.mt4dCommission[he[i]] = configs[he[i]]["4"]["11"].commission;
					this.mt4dRate[he[i]] = configs[he[i]]["4"]["11"].rate;
					this.mn4dCommission[he[i]] = configs[he[i]]["2"]["11"].commission;
					this.mn4dRate[he[i]] = configs[he[i]]["2"]["11"].rate;

					this.mbXien2Commission[he[i]] = configs[he[i]]["1"]["14"].commission;
					this.mbXien2Rate[he[i]] = configs[he[i]]["1"]["14"].rate;
					this.mtXien2Commission[he[i]] = configs[he[i]]["4"]["14"].commission;
					this.mtXien2Rate[he[i]] = configs[he[i]]["4"]["14"].rate;
					this.mnXien2Commission[he[i]] = configs[he[i]]["2"]["14"].commission;
					this.mnXien2Rate[he[i]] = configs[he[i]]["2"]["14"].rate;

					this.mnDaXien2Commission[he[i]] = configs[he[i]]["3"]["17"].commission;
					this.mnDaXien2Rate[he[i]] = configs[he[i]]["3"]["17"].rate;
				}
			}
		},
		methods:{
			loadUserConfig: function(code = null, klass='*'){
				let vm = this;

				let c = code ? code : (this.mode == "edit" ? this.$route.params.code : $("#parentCode").val());
				c = c ? c : this.user.code;

				if(c == "" && this.role == "house"){
					c = "admin";
				}

				if(c == "") return;

				axios.get('admin-panel/user-info/config?class='+klass+'&code='+ c)
					.then(res => {
						res = res.data;

						let d = vm.groupLimitConfig(res.data);
						vm.limitConfig = d;

						let h = vm.groupHeConfig(res.data);
						vm.heConfig = h;
					});
			},

			groupHeConfig: function(config){
				let data = {};

				for(let i=0;i<config.length;i++){
					if(!data[config[i].class]) data[config[i].class] = {};
					if(!data[config[i].class][config[i].game_id]) data[config[i].class][config[i].game_id] = {};
					config[i].game_title = this.gameInfo.games[config[i].game_id];
					config[i].prop_title = this.gameInfo.props[config[i].prop_id];
					data[config[i].class][config[i].game_id][config[i].prop_id] = config[i];
				}

				return data;
			},

			groupLimitConfig: function(config){
				let data = {};
				let vm = this;
				let keys = Object.keys(vm.uclass);
				let clss = this.mode == "edit" ? vm.uclass[keys[0]] : this.user.class[Object.keys(this.user.class)[0]];
				config = config.filter(e => {
					return e.class == clss; 
				});

				for(let i=0;i<config.length;i++){
					if(!data[config[i].game_id]) data[config[i].game_id] = {};
					config[i].game_title = this.gameInfo.games[config[i].game_id];
					config[i].prop_title = this.gameInfo.props[config[i].prop_id];
					data[config[i].game_id][config[i].prop_id] = config[i];
				}

				let tmp = {"_1": data[1],"_4": data[4],"_2": data[2],"_3": data[3]};
				return tmp;
			},

			getValueChange: function(selector, key=""){
				let change = {};

				let inputs = $(selector).toArray().filter((e) => {
					let current = $(e);
					return current.val() != "" && current.val() != current.attr("origin");
				}).map((e)=> {
					let current = $(e);
					let d = { "gameId": parseInt(current.attr("gameid")), "propId": parseInt(current.attr("propid")) };

					let classId = parseInt(current.attr("classid"));
					let attr = key;

					if(classId){
						d["class"] = classId;
						attr = selector.indexOf("rate") >= 0 ? "rate" : "commission";
						d[attr] = selector.indexOf("rate") >= 0 ? parseInt(current.val()) : parseFloat(current.val());
					}else{
						d[attr] = parseInt(current.val()); //limit
					}

					return d;
				});

				return inputs;
			},
		}
	}
</script>

<style>
	.table-config input{
	    border: none;
	    text-align: center;
	    background: none;
	}
</style>